module.exports = __webpack_public_path__ + "static/media/loading-eclipse-optimized.2b57e178.gif";